export default __webpack_public_path__ + "static/media/FrontOffice.563ea0d3.svg";